import React, { useState } from 'react';
import '../styles/blog.css';

const BlogCarousel = () => {
  const blogs = [
    {
      id: 1,
      title: "How to Register and Verify Your Account on the Reddyanna App",
      image: "/blog1.webp",
      slug: 'how-to-register-and-verify-your-account-on-the-reddyanna-app', 
    },
    {
      id: 2,
      title: "Reddy Anna App: Features, Benefits, and Installation Guide",
      image: '/blog2.webp', 
    slug: 'reddy-anna-app-features-benefits-and-installation-guide',
    },
  {
    id:3,
      title: "Online Cricket Betting: From How to Place Bet to Successful Tips",
      image: "/blog3.webp",
      slug: "online-cricket-betting-from-how-to-place-bet-to-successful-tips",
  },
  {
    id:4,
      title: "Cricket Betting Tips 2025: Expert Guide for Beginners to Win Big",
      image: "/blog4.webp",
      slug: "cricket-betting-tips-2025-expert-guide-for-beginners-to-win-big",
  },
  {
  id: 5,
  title: "Exploring the Exciting World of Cricket Betting Exchanges",
  image: "/blog5.webp",
  slug: "exploring-the-exciting-world-of-cricket-betting-exchanges",
},
// {
//   id: 6,
//   title: "Decoding the Matrix: A Guide into Cricket Betting Odds",
//   image: "/blog6.webp",
//   slug: "decoding-the-matrix-a-guide-into-cricket-betting-odds",
// }
{
  id: 7,
  slug: "the-art-and-science-of-cricket-betting-prediction",
  title: "The Art and Science of Cricket Betting Prediction",
  views: 6121,
  image: "/blog7.webp",
},
  ];

  const [currentIndex, setCurrentIndex] = useState(0);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? blogs.length - 1 : prevIndex - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex === blogs.length - 1 ? 0 : prevIndex + 1));
  };

  return (
    <div className="blog-carousel">
        {/* Sky-Blue Heading Card */}
        <div className="carousel-heading-card">
          <h2>Reddy Anna Blog</h2>
          <p>Read our blog for betting tips, tricks, and Reddy Anna Match Predictions here.</p>
        </div>

        {/* Blog Content Section */}
        <div className="carousel-content-section">
          <div className="carousel-card">
            {/* Blog Image Card */}
            <div className="carousel-image-card">
              <img src={blogs[currentIndex].image} alt={blogs[currentIndex].title} />
            </div>

            {/* Blog Content Card */}
            <div className="carousel-text-card">
              <h3>{blogs[currentIndex].title}</h3>
              <a href={`/blogs/${blogs[currentIndex].slug}`} className="read-more">
                Read More
              </a>
            </div>
          </div>

          {/* Carousel Navigation */}
          <div className="carousel-navigation">
            <button onClick={handlePrev} className="carousel-btn">←</button>
            <button onClick={handleNext} className="carousel-btn">→</button>
          </div>
        </div>
      </div>
  );
};

export default BlogCarousel;
